export default {
  test: {
    name: "测试",
    list: "列表",
  },
};
